import type { Module } from "@/types/modules";
import { AgentsHome } from "./redesign/AgentsHome";
import "../_infrastructure/ModuleStyles.css";
import "./AgentsModule.css";
import "./redesign/agents-redesign.css";

/**
 * Agents module — the redesign UI (fixtures track). The center pane is the agents shell:
 * module-view tabs → roster grid / horizontal agent bar + detail. No second vertical
 * sidebar. Backed by typed fixtures (modules/agents/redesign/*) until the live endpoints
 * land; the client interface swaps without component changes.
 *
 * The live-API surface (components/{ApprovalInbox,AgentRoster,ApprovalCard}, useAgentTrust,
 * lib/api/endpoints/agent-trust) and the backend gate substrate ship in this same PR; the
 * fixtures UI is what renders today, and converges onto those live endpoints next.
 */
export default function AgentsModule({
  module: _module,
  conversationId: _conversationId,
}: {
  module: Module;
  conversationId: string;
}) {
  return (
    <div className="module agents-module">
      <div className="module-content xv-scroll">
        <AgentsHome />
      </div>
    </div>
  );
}
